import { ObjectSerializer } from "../Serialization/ObjectSerializer";

export class DiscoveryTaskHandle implements ObjectSerializer {

    public ServerInstanceId: number;
    public TaskId: number;

    constructor(serverInstId?: number, taskId?: number) {
        this.Clear();

        if (serverInstId !== undefined)
            this.ServerInstanceId = serverInstId;

        if (taskId !== undefined)
            this.TaskId = taskId;
    }

    public get HasServerInstanceId(): boolean {
        return (this.ServerInstanceId >= 0);
    }

    public get HasTaskId(): boolean {
        return (this.TaskId >= 0);
    }

    public get IsValid(): boolean {
        return (this.HasServerInstanceId && this.HasTaskId);
    }

    public Clear(): void {
        this.ServerInstanceId = -1;
        this.TaskId = -1;
    }

    public Equals(other: DiscoveryTaskHandle): boolean {
        if (other == null)
            return false;
        return (this.ServerInstanceId === other.ServerInstanceId &&
                this.TaskId === other.TaskId);
    }

    public toString(): string {
        return this.ServerInstanceId + ":" + this.TaskId;
    }

    public Write(obj: any, context: any): void {
        obj.discovery_task_handle = {};
        obj = obj.discovery_task_handle;

        obj.server_instance_id = this.ServerInstanceId;
        obj.task_id = this.TaskId;
    }

    public Read(obj: any, context: any): void {
        this.Clear();

        if (!obj.discovery_task_handle) {
            throw new Error();
        }
        obj = obj.discovery_task_handle;

        if (obj.server_instance_id !== undefined)
            this.ServerInstanceId = obj.server_instance_id;

        if (obj.task_id !== undefined)
            this.TaskId = obj.task_id;
    }

}
